module.exports = __webpack_public_path__ + "img/icon-create-success.ec201ada.png";